import React from "react";
import CatalogoPageLayout from "./CatalogoPageLayout";

const CatalogoBancosPage: React.FC = () => (
  <CatalogoPageLayout
    title="Bancos y chequeras"
    description="Gestioná bancos, cuentas corrientes y chequeras para pagos y conciliaciones."
    helperText="Este apartado integrará tesorería, pagos a proveedores y emisión de cheques."
  />
);

export default CatalogoBancosPage;
